import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const YoutubeIcon = ({ color = '#292D32', size = 22, strokeWidth = 1.2, className, onClick }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11Z" fill="#FF0209" />
    <path d="M15.6695 15.8722C15.3418 15.9077 15.0063 15.9139 14.6848 15.9132C12.1765 15.9108 9.66827 15.9085 7.16079 15.907C6.3716 15.907 5.51207 15.8815 4.9022 15.3798C4.21504 14.8132 4.07204 13.8308 4.01639 12.9419C3.93909 11.7237 3.93291 10.5017 3.99629 9.2827C4.03107 8.61331 4.09214 7.9277 4.38045 7.3217C4.5876 6.88652 4.93312 6.4954 5.37525 6.2898C5.88927 6.05095 6.42725 6.09346 6.98069 6.09269C8.30555 6.09115 9.6304 6.09037 10.9553 6.08883C12.3327 6.08728 13.7109 6.08651 15.0883 6.08496C15.7391 6.08496 16.4379 6.0981 16.9689 6.47453C17.6545 6.95995 17.8408 7.88364 17.9266 8.71921C18.085 10.2582 18.0874 11.8134 17.9328 13.3523C17.8686 13.9869 17.7619 14.6579 17.3438 15.1394C16.9295 15.6171 16.315 15.8011 15.6703 15.8714L15.6695 15.8722Z" fill="white" />
    <path d="M13.2439 11.0004L9.50586 8.84229V13.1585L13.2439 11.0004Z" fill="#FF0209" />
  </svg>



);

export default YoutubeIcon;